import type { Data } from '@/api/api.ts'
import type {
  BalanceChoices,
  BalanceDataParams,
  BalanceDataWrapper,
  BalanceReport,
  BalanceRequest,
  BalanceSumOfPeriodData,
} from '@/types/balance.types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}balance/`

export const getBalance = async (): Promise<Data<BalanceRequest>> => axios.get(`${urlPrefix}info/`)

export const getBalanceChoices = async (): Promise<Data<BalanceChoices>> =>
  axios.get(`${urlPrefix}list/`, {
    params: {
      is_initial: 1,
    },
  })

export const getSumOfPeriod = async (params: BalanceDataParams): Promise<Data<BalanceSumOfPeriodData>> =>
  axios.get(`${urlPrefix}list/sum/`, { params })

export const getBalanceData = async (params: BalanceDataParams): Promise<Data<BalanceDataWrapper>> =>
  axios.get(`${urlPrefix}list/`, { params })

export const getBalanceReport = async (params: BalanceDataParams): Promise<Data<BalanceReport>> =>
  axios.get(`${urlPrefix}report/`, { params })
